<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/part1">Part I. Entertainment</a></p>
<p class="toc"><span href="#/part2" title="Link target outside of Sample">Part II. Special Events</span></p>
<p class="toc"><span href="#/part3" title="Link target outside of Sample">Part III. Moments to Remember</span></p>
<p class="toc"><span href="#/part4" title="Link target outside of Sample">Part IV. Hard Times</span></p>
<p class="toc"><span href="#/part5" title="Link target outside of Sample">Part V. Strange as It May Seem</span></p>
<p class="toc"><span href="#/part6" title="Link target outside of Sample">Part VI. Amazing and True</span></p>
<p class="toc1"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/appendex" title="Link target outside of Sample">Appendix: Tried and True Recipes from the Good Ol’ Piedmont Triad Days</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1f599fd5